import { ICompanyServicePlan } from "modules/company/types";

export const eventContentLimit = (plan: ICompanyServicePlan | null): number =>
  plan?.settings.event.contents || 0;
